import { render, staticRenderFns } from "./MobileAppAccess.vue?vue&type=template&id=ec90df70&scoped=true&"
import script from "./MobileAppAccess.vue?vue&type=script&lang=js&"
export * from "./MobileAppAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec90df70",
  null
  
)

export default component.exports